import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastAlertService {

  /**
 * Constructor
 *
 * @param {ToastrService} toastr
 */
  constructor(
    private toastr: ToastrService,
  ) { }

  private readonly toastTypes: Record<string, (message: string, title?: string) => void> = {
    success: (message, title) => this.toastr.success(message, title),
    error: (message, title) => this.toastr.error(message, title),
    warning: (message, title) => this.toastr.warning(message, title),
    info: (message, title) => this.toastr.info(message, title)
  }

  public auto(type: string, message: string, title: string = '') {
    const toastType = this.toastTypes[type.toLowerCase()]

    toastType ? toastType(message, title) : this.error('Ha habido un error al mostrar la alerta')
  }

  public success(message: string, title: string = 'Éxito'): void {
    this.toastr.success(message, title);
  }

  public error(message: string, title: string = 'Error'): void {
    this.toastr.error(message, title);
  }

  public warning(message: string, title: string = 'Advertencia'): void {
    this.toastr.warning(message, title);
  }

  public info(message: string, title: string = 'Información'): void {
    this.toastr.info(message, title);
  }
}
